import Text from '@creator/ui/components/Text/Text';
import CreateFeedItemInput from '@src/components/Token/CreateFeedItemInput/CreateFeedItemInput';
import { useStoreState } from '@src/model/hooks';
import { storeEqualityFn } from '@src/utils/object-utils/object-utils';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import CommunityPosts from './CommunityPosts';

export interface CommunitySectionProps {
    tokenName: string;
    flairId?: string;
    hideSeparator?: boolean;
}

const CommunitySection: React.FC<CommunitySectionProps> = props => {
    const { tokenName, flairId, hideSeparator } = props;
    const { t } = useTranslation();

    const token = useStoreState(state => state.token.getToken(tokenName), storeEqualityFn);

    function renderCommunityPostListSeparator() {
        if (hideSeparator) return null;

        return (
            <div className="p-4 text-lg font-medium bg-gray-950 dark:bg-gray-800 text-gray-50">
                <Text className="block font-medium text-center text-ellipsis">{t('tokenPage.postsTab.communityPostList.title', { tokenName: token?.title || tokenName })}</Text>
            </div>
        );
    }

    return (
        <div className={`space-y-4 ${hideSeparator && 'pt-4'}`}>
            {renderCommunityPostListSeparator()}
            <CreateFeedItemInput className="px-4" postKind="community" tokenName={tokenName} />
            <CommunityPosts className="px-4" tokenName={tokenName} flairId={flairId} />
        </div>
    );
};

export default memo(CommunitySection);
